import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { normalizeLang } from "./lang.utils";

// 自动加载语言文件
const messages: any = {};
const modules: any = import.meta.glob("./locales/*.ts", {
  eager: true,
});
Object.keys(modules).forEach(key => {
  const fileName = key.replace(/.*\/locales\/([^\/]*)*.ts/gi, "$1");
  messages[fileName] = {};
  messages[fileName]["translation"] = modules[key].default;
});

// 域名 -> 语言 映射表
const langMap = {
  ...messages, // 英语域名
  get en_v_ls_comfortweather_com() {
    return this["en"];
  },
  // 泰语域名
  get th_v_ls_comfortweather_com() {
    return this["th"];
  },
  // 印尼语域名
  get id_v_ls_comfortweather_com() {
    return this["id"];
  },

  // 美国
  get en_mxwg_comfortweather_com() {
    return this["en"];
  },
  // 墨西哥
  get es_mxwg_comfortweather_com() {
    return this["es"];
  },

  // 印地语域名
  get hi_v_ls_comfortweather_com() {
    return this["hi"];
  },
  // 越南语域名
  get vi_v_ls_comfortweather_com() {
    return this["vi"];
  },
  // 小米天气的小部件英文域名
  get en_miwg_comfortweather_com() {
    return this["en"];
  },
  // 小米印地语域名
  get hi_miwg_comfortweather_com() {
    return this["hi"];
  },
  // 小米印尼语域名
  get id_miwg_comfortweather_com() {
    return this["id"];
  },

  // 巴西葡萄牙语
  get pt_br_mils_comfortweather_com() {
    return this["pt"];
  },
  // 欧洲_葡萄牙语
  get pt_mils_comfortweather_com() {
    return this["pt_pt"];
  },
  // 西班牙语
  get es_mils_comfortweather_com() {
    return this["es"];
  },

  // 阿拉伯语
  get arabic_mils_comfortweather_com() {
    return this["ar"];
  },
  // 土耳其语
  get tr_mils_comfortweather_com() {
    return this["tr_tr"];
  },
  // 法语
  get fr_mils_comfortweather_com() {
    return this["fr_fr"];
  },
  // 意大利语
  get it_mils_comfortweather_com() {
    return this["it_it"];
  },
  // 乌尔都语
  get urdu_mils_comfortweather_com() {
    return this["ur"];
  },
  // 越南语
  get vi_mils_comfortweather_com() {
    return this["vi"];
  },
  // 泰语
  get th_mils_comfortweather_com() {
    return this["th"];
  },
  // 英语
  get en_mils_comfortweather_com() {
    return this["en"];
  },
  // 日语
  get jp_mils_comfortweather_com() {
    return this["ja_jp"];
  },
  // 德语
  get ger_mils_comfortweather_com() {
    return this["de_de"];
  },
  // 印尼语
  get id_mils_comfortweather_com() {
    return this["id"];
  },
  // 波兰语
  get po_mils_comfortweather_com() {
    return this["pl_pl"];
  },
  // 印尼语
  get id_wi_comfortweather_com() {
    return this["id"];
  },
  // 西班牙语
  get es_wi_comfortweather_com() {
    return this["es"];
  },
  // 英语域名
  get en_wg_comfortweather_com() {
    return this["en"];
  },
  get mos_comfortweather_com() {
    return this["en"];
  },
  // 印地语域名
  get hi_wg_comfortweather_com() {
    return this["hi"];
  },
  // 印尼语域名
  get id_wg_comfortweather_com() {
    return this["id"];
  },
  // 西班牙语域名
  get es_wg_comfortweather_com() {
    return this["es"];
  },

  // 巴西_葡萄牙语
  get pt_br_wg_comfortweather_com() {
    return this["pt"];
  },
  // 孟加拉语
  get bn_mils_comfortweather_com() {
    return this["bn_bd"];
  },

  // 希腊语
  get el_mils_comfortweather_com() {
    return this["el_gr"];
  },

  // 希伯来语
  get he_mils_comfortweather_com() {
    return this["he"];
  },

  // 韩语
  get ko_mils_comfortweather_com() {
    return this["ko"];
  },

  // 乌克兰语
  get uk_mils_comfortweather_com() {
    return this["uk"];
  },

  // 缅甸语
  get my_mils_comfortweather_com() {
    return this["en"];
  },

  // 俄语
  get ru_mils_comfortweather_com() {
    return this["ru_ru"];
  },

  get rs_mils_comfortweather_com() {
    return this["ru_ru"];
  },
  // 阿塞拜疆语
  get az_mils_comfortweather_com() {
    return this["az_latn_az"];
  },

  // 匈牙利语
  get hu_mils_comfortweather_com() {
    return this["hu_hu"];
  },

  // 罗马尼亚语
  get ro_mils_comfortweather_com() {
    return this["ro_ro"];
  },

  // 塞尔维亚语
  get sr_mils_comfortweather_com() {
    return this["sr_rs"];
  },

  // 保加利亚语
  get bg_mils_comfortweather_com() {
    return this["bg"];
  },

  // 斯洛伐克语
  get sk_mils_comfortweather_com() {
    return this["sk"];
  },

  // 繁体中文
  get zh_hant_mils_comfortweather_com() {
    return this["zh_hant"];
  },
  // 僧伽罗语
  get si_mils_comfortweather_com() {
    return this["si"];
  },
  // 捷克语
  get cs_mils_comfortweather_com() {
    return this["cs"];
  },
  // go机型新增单独俄罗斯的子域名
  get rs_miwg_comfortweather_com() {
    return this["ru_ru"];
  },
  //  小部件的俄罗斯域名新增域名
  get rs_wg_comfortweather_com() {
    return this["ru_ru"];
  },
};

const localeMap = Object.keys(langMap);
const langKey = Object.keys(messages);

// 获取当前环境信息
const { lan: originLan } = useLanguage("");
const lan = normalizeLang(originLan);
const { subdomain: originSub, domain } = useSubdomain();
const subdomain = normalizeLang(originSub);
const { hostName } = useHostName();
const hostNameNormalized = normalizeLang(hostName);

// 获取最终语言
function getLanguageKey() {
  // 1. 优先使用 URL 参数中的语言
  if (langKey.includes(lan)) return lan;

  // 2. 特殊域名 wx.mobi321.com 强制使用俄语
  if (domain === "wx.mobi321.com") return "ru_ru";

  // 3. 排除测试和 www 子域名
  if (["test", "www"].includes(subdomain)) return "en";

  // 4. 按优先级匹配语言
  if (localeMap.includes(hostNameNormalized)) return hostNameNormalized;

  const subDomainKey = `${subdomain}_comfortweather_com`;
  if (localeMap.includes(subDomainKey)) return subDomainKey;

  // 5. 默认返回英语
  return "en";
}

const lng = getLanguageKey();

// 初始化 i18n
i18n.use(initReactI18next).init({
  lng: lng,
  debug: !!isDevEnv,
  interpolation: { escapeValue: false },
  resources: langMap,
});

// 开发环境打印
if (isDevEnv || isBuildTest) {
  console.table({ langKey, langMap, lng });
}

export { langMap, localeMap, langKey, lng };
export default i18n;
